import error from "./error.json";
import accountManagement from "./accountManagement.json";
import invitationCode from "./invitationCode.json";
import userInfoGuide from "./userInfoGuide";
import personalCenter from "./personalCenter.json";
import onlineResume from "./onlineResume.json";
import attachmentManager from "./attachmentManager.json";
import attachmentResume from "./attachmentResume.json";
import salaryRange from "./salaryRange";
export default {
    ...error,
    ...accountManagement,
    ...invitationCode,
    ...personalCenter,
    userInfoGuide: { ...userInfoGuide },
    salaryRange: { ...salaryRange },
    ...attachmentManager,
    ...onlineResume,
    ...attachmentResume
};
